import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

/**
 * Global footer with the intermediation-terms sentence provided by the client.
 * Used inside `Layout.jsx` (rendered on every dealer/authenticated page) and
 * also inline at the bottom of `SecureTrade.jsx` and legal pages so the
 * disclaimer is visible everywhere.
 */
export default function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="app-footer"
      className="mt-16 border-t border-slate-200 bg-white/70 py-8"
    >
      <div className="mx-auto max-w-5xl px-6 text-center">
        <p
          data-testid="footer-terms-sentence"
          className="text-[12px] leading-tight md:text-[12px] md:leading-snug text-slate-500 italic"
        >
          {t("footer.terms_sentence")}
        </p>
        <nav
          data-testid="footer-legal-nav"
          className="mt-4 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-[11px] font-semibold uppercase tracking-[0.16em] text-slate-500"
        >
          <Link
            to="/impressum"
            data-testid="footer-link-impressum"
            className="hover:text-slate-900 transition-colors"
          >
            {t("footer.impressum")}
          </Link>
          <span aria-hidden className="text-slate-300">·</span>
          <Link
            to="/privacy"
            data-testid="footer-link-privacy"
            className="hover:text-slate-900 transition-colors"
          >
            {t("footer.privacy")}
          </Link>
          <span aria-hidden className="text-slate-300">·</span>
          <Link
            to="/contatti"
            data-testid="footer-link-contact"
            className="hover:text-slate-900 transition-colors"
          >
            {t("footer.contact")}
          </Link>
          <span aria-hidden className="text-slate-300">·</span>
          <Link
            to="/privati"
            data-testid="footer-link-privati"
            className="hover:text-slate-900 transition-colors"
          >
            {t("footer.privati")}
          </Link>
        </nav>
        <p className="mt-3 text-[10px] uppercase tracking-[0.24em] text-slate-400 font-semibold">
          © {year} AUTEXIO
        </p>
      </div>
    </footer>
  );
}
